import apiService from './apiService';
import hokakuApiService from './hokakuApiService';

const BASE_URL = 'wildlifeDamage';
const FENCE_URL = 'wildlifeDamageMap';

/**
 * 鳥獣被害（柵含む）リスト取得
 */
export const getWildlifeDamageList = async (filterData) => {
    return apiService.post(`${BASE_URL}/getList`, filterData);
};

/**
 * 柵情報登録
 * @param {Object} fenceData - 登録する柵のデータ
 * @returns {Promise} API レスポンス
 */
export const registerFence = async (fenceData) => {
    return apiService.post(`${FENCE_URL}/regist`, fenceData);
};

/**
 * 柵情報更新
 * @param {Object} fenceData - 更新する柵のデータ
 * @returns {Promise} API レスポンス
 */
export const updateFence = async (fenceData) => {
    return apiService.post(`${FENCE_URL}/update`, fenceData);
};

/**
 * 柵情報削除（論理削除）
 * @param {Object} primaryKey - 削除対象データのプライマリキー
 * @returns {Promise} API レスポンス
 */
export const deleteFence = async (primaryKey) => {
    return apiService.post(`${FENCE_URL}/delete`, primaryKey);
};

/**
 * 捕獲情報取得（都道府県単位）
 * 指定した地域IDに紐づく捕獲情報一覧を取得する
 *
 * @param {number|string} prefecture_id - 地域ID（region_id）
 * @param {date} date_begin - 開始日付
 * @param {date} date_end - 終了日付
 * @returns {Promise<Array<Object>>} 捕獲情報一覧
 * @returns {Promise<Array<Object>>} resolve時：捕獲データ配列
 */
export const getHokakuList = async (prefecture_id, date_begin, date_end) => {
    try {
        const response = await hokakuApiService.get(
            `/app/captures/prefecture/${prefecture_id}`,
            {
                params: {
                    date_begin: date_begin,
                    date_end: date_end
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('error', error);
    }
};

export const fetchGeoJSON = async (prefectureId) => {
    try {
        const response = await hokakuApiService.get(`/app/preserve_file/prefecture/${prefectureId}`);
        return response;
    } catch (error) {
        console.error('error', error);
    }
};
